import * as React from 'react';
import { selectBuilderInfo } from '../../selectors/builder';
import { useSelector } from 'react-redux';
import { CallButton } from '../../components/CallButton';
import { TButtonSize } from '@cian/ui-kit/button/types';

interface ICallButtonContainerProps {
  size?: TButtonSize;
  onClick?(): void;
}

export const CallButtonContainer: React.FC<ICallButtonContainerProps> = ({ size, onClick }) => {
  const { phone } = useSelector(selectBuilderInfo);

  if (!phone) {
    return null;
  }

  return <CallButton phone={phone} size={size} onClick={onClick} />;
};
